import { X } from 'lucide-react';
import { useCountryStore } from '../../shared/country/countryStore';
import { marketCopyKey } from '../../shared/country/marketCopy';
import { useI18nStore } from '../../shared/i18n/i18nStore';

export function GuestAuthSheet({
  onSignup,
  onLogin,
  onClose,
  // RoomPage stacks this sheet over its own bet sheet, so it genuinely needs
  // the darker `nested-sheet-backdrop` scrim (z-index 55) and passes it
  // explicitly. Callers with no sheet underneath (e.g. the leaderboard) get
  // the plain first-level `sheet-backdrop` scrim by default.
  backdropClassName = 'sheet-backdrop',
}: {
  onSignup: () => void;
  onLogin: () => void;
  onClose: () => void;
  backdropClassName?: string;
}) {
  const t = useI18nStore((state) => state.t);
  const countryCode = useCountryStore((state) => state.country.code);
  return (
    <div className={backdropClassName} role="presentation" onMouseDown={onClose}>
      <section className="profile-sheet guest-auth-sheet-react" role="dialog" aria-modal="true" aria-label={t('guestSheetTitle')} onMouseDown={(event) => event.stopPropagation()} data-guest-auth-sheet-react="true">
        <div className="sheet-grabber" />
        <header className="sheet-header">
          <div>
            <h2>{t('guestSheetTitle')}</h2>
            <p>{t(marketCopyKey('guestSheetBody', countryCode))}</p>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label={t('close')}>
            <X size={18} aria-hidden="true" />
          </button>
        </header>
        <div className="guest-auth-actions-react">
          <button className="primary-button" type="button" onClick={onSignup}>{t('guestSheetSignup')}</button>
          <button className="secondary-button" type="button" onClick={onLogin}>{t('guestSheetLogin')}</button>
          <button className="link-button" type="button" onClick={onClose}>{t('guestSheetCancel')}</button>
        </div>
      </section>
    </div>
  );
}
